/* =====================================================================
   PROMO LANDING PAGES — HiPP Dutch 3+1 (templates page.promo-dutch and
   page.promo-dutch-meta). Loaded only when rd_promo is set.

   Five small behaviours, each bound to what the served HTML already carries:

     1. the buy box — stage select, price lines, and ADD TO CART GOES
        STRAIGHT TO CHECKOUT
     2. the fulfilment-cutoff countdown in the hero
     3. the gallery (scroll-snap track, arrows, thumbnails)
     4. the tabs (Preparation / Ingredients / Nutrition / FAQ)
     5. the review carousel's arrows and dots

   The FAQ accordion, the terms modal and the video tiles are the site's own
   components, bound by redesign.js — nothing here re-implements them.
   ===================================================================== */
(function () {
  'use strict';

  /* rdMoney (assets/redesign.js) formats in the session's currency. This
     used to paint with shop.money_format off a data attribute — the STORE's
     dollar format, whatever currency the page had been priced in. opts are
     rdMoney's; the fallback is that old format, for a page where redesign.js
     failed to load. */
  function money(cents, opts) {
    if (window.rdMoney) return window.rdMoney.format(cents, opts);
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* --------------------------------------------------------------- buy box
     ONE starter line, and nothing else, in the checkout.

     The 3+1 Pack is a subscription-only variant (plan "Deliver every 12
     days"), and Shopify's cart permalinks do not carry selling plans — which
     is the one thing the competitor's /cart/<id>:4?discount= link relies on.
     So: empty the cart, add the starter with its plan, and go to /checkout.

     Emptying first is deliberate. A permalink replaces the cart, and the
     brief is that the button lands in checkout "with the correct price" of
     the offer — a stale cart line from an earlier visit would change the
     total the shopper sees from the one on this page. It also makes a second
     click (back button, then Add To Cart again on another stage) replace the
     first bundle instead of adding a second.

     Without JavaScript the form still works: it posts id + selling_plan to
     /cart/add with return_to=/checkout. Only the clearing is lost. */
  function initBuy(root) {
    var form = root.querySelector('[data-pr-form]');
    var select = root.querySelector('[data-pr-stage]');
    if (!form || !select) return;
    var planInput = form.querySelector('[data-pr-plan]');
    var btn = form.querySelector('[data-pr-submit]');
    var err = root.querySelector('[data-pr-error]');

    function current() { return select.options[select.selectedIndex]; }

    function sync() {
      var o = current();
      if (!o) return;
      var d = o.dataset;
      if (planInput) planInput.value = d.plan || '';
      var total = parseInt(d.price, 10);
      var compare = parseInt(d.compare, 10);
      var save = compare - total;
      var units = parseInt(d.units, 10) || 1;
      var per = Math.floor(total / units);
      /* The price is the offer's total: it carries the currency code outside
         the store currency (D3), as the section's first paint does. */
      root.querySelectorAll('[data-pr-price]').forEach(function (el) { el.textContent = money(total, { withCode: true }); });
      root.querySelectorAll('[data-pr-compare]').forEach(function (el) {
        el.textContent = money(compare);
        (el.closest('.pr-buy__was') || el).hidden = !(compare > total);
      });
      root.querySelectorAll('[data-pr-save]').forEach(function (el) {
        el.textContent = money(save > 0 ? save : 0);
      });
      root.querySelectorAll('[data-pr-per]').forEach(function (el) { el.textContent = money(per); });
      /* Each stage's gallery is rendered; only the chosen one shows. */
      root.querySelectorAll('[data-pr-gallery]').forEach(function (g) {
        g.hidden = g.getAttribute('data-pr-gallery') !== o.value;
      });
      /* Anything else on the page that belongs to one stage's product (the
         tabs' ingredients, nutrition and FAQ) follows the choice too; left
         alone when none of it is for this product. */
      var own = document.querySelectorAll('[data-pr-for-product]');
      var hit = false;
      own.forEach(function (el) { if (el.getAttribute('data-pr-for-product') === d.product) hit = true; });
      if (hit) own.forEach(function (el) { el.hidden = el.getAttribute('data-pr-for-product') !== d.product; });
      if (btn) btn.disabled = d.available !== 'true' || root.hasAttribute('data-pr-withheld');
      if (err) err.hidden = true;
    }

    select.addEventListener('change', function () {
      sync();
      /* Page two carries the buy box twice; keep the other copy on the same
         stage so scrolling back up does not show a different choice. */
      document.querySelectorAll('[data-pr-buy] [data-pr-stage]').forEach(function (other) {
        if (other !== select && other.value !== select.value) {
          other.value = select.value;
          other.dispatchEvent(new Event('change'));
        }
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.JSON) return;   /* native post: add + return_to */
      e.preventDefault();
      if (btn.disabled) return;
      var o = current();
      var item = { id: parseInt(o.value, 10), quantity: 1 };
      if (o.dataset.plan) item.selling_plan = parseInt(o.dataset.plan, 10);

      btn.disabled = true;
      root.classList.add('is-busy');
      if (err) err.hidden = true;

      fetch('/cart/clear.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: '{}'
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      }).then(function (r) {
        if (r.ok) {
          /* Make sure the line survived before handing over to checkout — a
             third-party cart write can wipe an add that answered 200 (the
             lost-add guard in redesign.js says why). Quick here: read at once,
             again 400ms later only if something is short, re-add, then go. */
          return r.json().then(function (data) {
            return window.rdCartGuard ? window.rdCartGuard.watch(data, null, { delay: 0, gap: 400 }) : false;
          }, function () {}).then(function () { window.location.href = '/checkout'; });
        }
        /* 422 is Shopify refusing the line itself (sold out, plan missing):
           say so. Anything else — a 429 from the storefront's bot check, a
           5xx — is the channel failing, not the cart. */
        if (r.status !== 422) { var e = new Error('cart/add ' + r.status); e.channel = true; throw e; }
        return r.json().then(function (j) {
          throw new Error(j.description || j.message || 'cart/add ' + r.status);
        }, function () { throw new Error('cart/add ' + r.status); });
      }).catch(function (x) {
        console.error('Promo checkout failed:', x);
        /* The channel failed (network, 429, 5xx): hand over to the plain form
           post, which adds the same line with return_to=/checkout as a normal
           navigation. A visitor the bot check wants to verify then sees and
           passes its page instead of a dead button. form.submit() skips this
           handler, so it cannot loop. */
        if (!x || x.channel || x instanceof TypeError) { form.submit(); return; }
        root.classList.remove('is-busy');
        btn.disabled = false;
        if (err) {
          var msg = x.message && !/^cart\/add \d+$/.test(x.message) ? x.message : '';
          err.textContent = msg || err.getAttribute('data-default');
          err.hidden = false;
        }
      });
    });

    /* A back-navigation from checkout restores this page from the bfcache
       with the button still disabled and the spinner still turning. */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      root.classList.remove('is-busy');
      sync();
    });

    sync();
  }

  /* ------------------------------------------------------ cutoff countdown
     Counts down to the warehouse's next fulfilment cutoff: 06:00 and 12:00
     German wall-clock time (Sam, 1 Sep 2026). Same rule, same copy and the
     same Europe/Berlin resolution as the cart's pill in
     snippets/rd-cart-cutoff.liquid — KEEP THE TWO IN STEP. A real deadline
     rather than an evergreen timer: miss both cutoffs and it runs to 06:00
     the next day. Hidden if Intl cannot resolve Berlin. */
  function initCutoff(el) {
    var CUTOFFS = [6, 12];
    var ZONE = 'Europe/Berlin';
    var hh = el.querySelector('[data-pr-h]'), mm = el.querySelector('[data-pr-m]'), ss = el.querySelector('[data-pr-s]');

    function fields(date) {
      try {
        var p = {};
        new Intl.DateTimeFormat('en-US', {
          timeZone: ZONE, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
        return { y: +p.year, mo: +p.month - 1, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second };
      } catch (e) { return null; }
    }
    function offset(date) {
      var f = fields(date);
      return f ? Date.UTC(f.y, f.mo, f.d, f.h, f.mi, f.s) - Math.floor(date.getTime() / 1000) * 1000 : null;
    }
    function instant(y, mo, d, h) {
      var naive = Date.UTC(y, mo, d, h, 0, 0);
      var off = offset(new Date(naive));
      if (off === null) return null;
      var t = naive - off, off2 = offset(new Date(t));
      if (off2 !== null && off2 !== off) t = naive - off2;
      return new Date(t);
    }
    function next(now) {
      var b = fields(now);
      if (!b) return null;
      for (var i = 0; i < CUTOFFS.length; i++) {
        if (b.h < CUTOFFS[i]) return { at: instant(b.y, b.mo, b.d, CUTOFFS[i]), sameDay: true };
      }
      var t = new Date(Date.UTC(b.y, b.mo, b.d, 12, 0, 0));
      t.setUTCDate(t.getUTCDate() + 1);
      return { at: instant(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), CUTOFFS[0]), sameDay: false };
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var now = new Date(), n = next(now);
      if (!n || !n.at) { el.hidden = true; return; }
      var ms = n.at.getTime() - now.getTime();
      if (ms <= 0) { setTimeout(tick, 1000); return; }
      var s = Math.floor(ms / 1000);
      hh.textContent = pad(Math.floor(s / 3600));
      mm.textContent = pad(Math.floor((s % 3600) / 60));
      ss.textContent = pad(s % 60);
      el.classList.add('is-live');
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  /* --------------------------------------------------------------- gallery */
  function initGallery(g) {
    var track = g.querySelector('[data-pr-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = g.querySelectorAll('[data-pr-thumb]');
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = index();
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var prev = g.querySelector('[data-pr-prev]'), nextBtn = g.querySelector('[data-pr-next]');
      if (prev) prev.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; mark(); });
    }, { passive: true });
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-pr-prev]')) go(index() - 1);
      else if (e.target.closest('[data-pr-next]')) go(index() + 1);
      else {
        var t = e.target.closest('[data-pr-thumb]');
        if (t) go(parseInt(t.getAttribute('data-pr-thumb'), 10));
      }
    });
    mark();
  }

  /* ------------------------------------------------------------------ tabs */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    function show(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t && root.contains(t)) show(t);
    });
    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) return;
      var list = Array.prototype.slice.call(tabs), i = list.indexOf(t);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = (i + 1) % list.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = (i - 1 + list.length) % list.length;
      else return;
      e.preventDefault();
      list[i].focus();
      show(list[i]);
    });
  }

  /* ------------------------------------------------------ review carousel */
  function initCarousel(root) {
    var track = root.querySelector('[data-pr-rtrack]');
    if (!track) return;
    var cards = track.children;
    var dots = root.querySelectorAll('[data-pr-dot]');
    function step() {
      var c = cards[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    function index() { return Math.round(track.scrollLeft / Math.max(1, step())); }
    function go(i) { track.scrollTo({ left: Math.max(0, i) * step(), behavior: 'smooth' }); }
    function mark() {
      var i = index();
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (atEnd) i = dots.length - 1;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var p = root.querySelector('[data-pr-rprev]'), n = root.querySelector('[data-pr-rnext]');
      if (p) p.disabled = track.scrollLeft <= 2;
      if (n) n.disabled = atEnd;
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; mark(); });
    }, { passive: true });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pr-rprev]')) go(index() - 1);
      else if (e.target.closest('[data-pr-rnext]')) go(index() + 1);
      else {
        var d = e.target.closest('[data-pr-dot]');
        if (d) go(parseInt(d.getAttribute('data-pr-dot'), 10));
      }
    });
    window.addEventListener('resize', mark);
    mark();
  }

  function init() {
    document.querySelectorAll('[data-pr-buy]').forEach(initBuy);
    document.querySelectorAll('[data-pr-cutoff]').forEach(initCutoff);
    document.querySelectorAll('[data-pr-gal]').forEach(initGallery);
    document.querySelectorAll('[data-pr-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-pr-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
